import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content"]
  static values = { expandableContentId: String }

  toggle(event) {
    // We need this to keep a click event on the parent from redirecting to the show page
    event.stopPropagation()
    const content = document.getElementById(this.expandableContentIdValue)
    content.classList.toggle("hidden")
    this.element.classList.toggle("rotate-90")
  }
}
